import { useState } from 'react'
import { cn } from '#app/shared/lib/misc.js'

export const Ripple = ({ className }: { className?: string }) => {
	const [state, setState] = useState({ spanStyles: {}, count: 0 })
	let bounce: any
	const callCleanUp = (cleanup: any, delay: any) => {
		return function () {
			clearTimeout(bounce)
			bounce = setTimeout(() => {
				cleanup()
			}, delay)
		}
	}

	const showRipple = (e: any) => {
		const rippleContainer = e.currentTarget
		const size = rippleContainer.offsetWidth
		const pos = rippleContainer.getBoundingClientRect()
		const x = e.pageX - pos.x - size / 2
		const y = e.pageY - pos.y - size / 2

		const spanStyles = {
			top: y + 'px',
			left: x + 'px',
			height: size + 'px',
			width: size + 'px',
		}
		const count = state.count + 1
		setState({
			spanStyles: { ...state.spanStyles, [count]: spanStyles },
			count: count,
		})
	}

	const cleanUp = () => {
		setState({ spanStyles: {}, count: 0 })
	}

	const renderRippleSpan = () => {
		const spanStyles: any = state.spanStyles
		const spanArray = Object.keys(spanStyles)
		if (spanArray && spanArray.length > 0) {
			return spanArray.map((key, index) => {
				return (
					<RippleSpan
						key={'spanCount_' + index}
						style={{ ...spanStyles[key] }}
						className={className}
					/>
				)
			})
		} else {
			return null
		}
	}
	return (
		// eslint-disable-next-line jsx-a11y/no-static-element-interactions
		<div
			className="absolute inset-0"
			onMouseDown={showRipple}
			onMouseUp={callCleanUp(cleanUp, 10000)}
		>
			{renderRippleSpan()}
		</div>
	)
}

const RippleSpan = (props: any) => {
	return (
		<span
			{...props}
			className={cn(
				'absolute scale-0 animate-ripple-enter rounded-full bg-white opacity-75',
				props.className,
			)}
		/>
	)
}
